import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const ACTIVE = ["queued", "rendering", "encoding", "validating"];

// Loads one 3D video job and keeps polling while it renders, so the card survives leaving the chat.
export function useRenderJob(jobId) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const prev = useRef(null);
  const load = useCallback(async () => {
    try {
      const { data: d } = await api.get(`/render3d/jobs/${jobId}`);
      setData(d);
      return d.job;
    } catch (e) {
      if (e.response?.status === 404) setData({ missing: true });
      return null;
    }
  }, [jobId]);

  useEffect(() => { load(); }, [load]);
  const status = data?.job?.status;
  useEffect(() => {
    if (!ACTIVE.includes(status)) return;
    const t = setInterval(load, 2500);
    return () => clearInterval(t);
  }, [status, load]);
  useEffect(() => {
    if (prev.current && ACTIVE.includes(prev.current) && status === "completed") window.dispatchEvent(new Event("stealth:balance-refresh"));
    prev.current = status;
  }, [status]);

  const act = async (path, body) => {
    setBusy(true);
    try {
      const { data: d } = await api.post(`/render3d/jobs/${jobId}/${path}`, body || {});
      setData((x) => ({ ...x, job: d.job }));
    } catch (e) {
      const detail = e.response?.data?.detail;
      toast.error(detail === "insufficient_credits" ? "You don't have enough Stealth Credits for this video." : (typeof detail === "string" ? detail : "That didn't work. Try again."));
    } finally { setBusy(false); }
  };
  return { data, busy, approve: (b) => act("approve", b), cancel: () => act("cancel"), retry: () => act("retry"), reload: load };
}

export const isActive = (s) => ACTIVE.includes(s);
